module.exports = __webpack_public_path__ + "static/about1-484317ab59d0f4daa903d2070115ffbd.jpg";